import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import Grid from "../components/Grid/Grid";
import GridTitle from "..//components/GridTitle/GridTitle";
import Footer from "../components/Footer/Footer";
import Channels from "../components/Channels/Channels";
import CategoryBanner from "../components/CategoryBanner/CategoryBanner";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import api from "../utils/api_calls";
import { StoreProvider } from "../contexts/store";
import "../../sass/_document.scss";

const apiUrl = `${
    ConfigurationHelper.getGlobalConfiguration().apiUrl
}/channels/${TVSite.channelId}/contents`;

const menuChannels = [
    { title: 'Trends', id: 224327992 }, // latest
    { title: 'Tile', id: 224327993 },
    { title: 'Stone', id: 224327994 },
    { title: 'Wood', id: 224327995 },
    { title: 'Laminate', id: 224983960 },
    { title: 'Vinyl', id: 224327997 },
    { title: 'Decoratives', id: 224327998 },
    { title: 'How-To', id: 224327999 }
];

class Channel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabActive: 1,
            shouldRenderBelow: true,
            isChannelMapped: true
        };
    }

    checkUrlparameter = () => {
        if (window.location && "search" in location) {
            location.search
                .substr(1)
                .split("&")
                .forEach((param) => {
                    const keyValue = param.split("=");
                    if (keyValue[0] === "sort" && keyValue[1] === "mr") {
                        this.setState({
                            tabActive: 1,
                        });
                    } else if (keyValue[0] === "sort" && keyValue[1] === "mv") {
                        this.setState({
                            tabActive: 2,
                        });
                    }
                });
        }
    };

    componentWillMount() {
        this.checkUrlparameter();
    }

    componentDidMount() {

        const urlParams = new URLSearchParams(window.location.search);
        let selectedChannelId = parseInt(urlParams.get("channelId"), 10) || 0;
        const pathParts = window.location.pathname.split("/");
        const channelIndex = pathParts.findIndex((part) => part === "c");
    
        // If channel ID is found in URL path (e.g., /c/{channelId})
        if (channelIndex !== -1 && pathParts[channelIndex + 2]) {
            selectedChannelId = parseInt(pathParts[channelIndex + 2], 10);
        }
    
        // Check if the selected channel is from the predefined list
        const selectedChannel = menuChannels.find(
            (channel) => channel.id === selectedChannelId
        );

        this.setState({
            isChannelMapped: !!selectedChannel
        });
    }

    getApiUrl = () => {
        if (this.state.tabActive === 1) return apiUrl;
        else if (this.state.tabActive === 2) return apiUrl + "?od=DESC&o=views";
    };

    onClick = (tabId) => {
        const { tabActive } = this.state;
        if (
            (tabActive === 1 && tabId === "mr") ||
            (tabActive === 2 && tabId === "mv")
        )
            return;
        window.location.href = `${TVSite.sub_folder}/${TVSite.channel.url}/?sort=${tabId}`;
    };0

    handleFlagChange = (flagValue) => {
        this.setState(() => {
            return { shouldRenderBelow: flagValue };
        });
    };

    render() {
        const { tabActive, shouldRenderBelow, isChannelMapped } = this.state;
        const channelApiUrl = this.getApiUrl();
        return (
            <div className="app-container-video">
                <div className="document-body" style={{paddingTop: !isChannelMapped ? "36px" : "unset"}}>
                    {isChannelMapped && (
                        <Channels onFlagChange={this.handleFlagChange} />
                    )}
                    {shouldRenderBelow && (
                        <>
                            <CategoryBanner channel={TVSite.channel} />
                            
                                <div
                                    className={"container grid-tabs-container"}
                                >
                                    <div className={"row"}>
                                        <div className={"col-md-6 tab-line"}>
                                            <GridTitle
                                                className={
                                                    "more-from-this-category"
                                                }
                                            >
                                                <span>
                                                    MORE FROM THIS CATEGORY
                                                </span>
                                            </GridTitle>
                                        </div>
                                        <div className={"col-md-6 tab-line"}>
                                            <div className={"grid-tabs"}>
                                                <div
                                                    onClick={() =>
                                                        this.onClick("mr")
                                                    }
                                                    className={
                                                        "grid-tab " +
                                                        (tabActive === 1
                                                            ? "active"
                                                            : "")
                                                    }
                                                >
                                                    <span>Most Recent</span>
                                                </div>
                                                <div
                                                    onClick={() =>
                                                        this.onClick("mv")
                                                    }
                                                    className={
                                                        "grid-tab " +
                                                        (tabActive === 2
                                                            ? "active"
                                                            : "")
                                                    }
                                                >
                                                    <span>Most Viewed</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                            <div className={"grid-container active"}>
                                
                                <Grid
                                    gridTitle=""
                                    baseApiUrl={channelApiUrl}
                                    videos={[]}
                                    analyticsForFistAsset={true}
                                    channel={{ id: TVSite.channelId }}
                                />
                                
                            </div>
                            {ConfigurationHelper.enableHeaderFooter() && (
                                <Footer />
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default Channel;

const targetEl = document.getElementById("app-container");
if (targetEl) {
    const root = createRoot(targetEl);
    root.render(<StoreProvider><Channel /></StoreProvider>);
}
